import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import type { ReactNode } from 'react';

export function PosthogProvider({ children }: PosthogProviderProps) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}

export interface PosthogProviderProps {
  children: ReactNode;
}
